module.exports = __webpack_public_path__ + "theme/assets/img/60e70831354d8167d19fdd9d891c298d.jpg";